// -----------------------------------------------------------------------------
// ProductFormModal — Modal d'ajout / modification d'un produit
// StockPro / VisualisPro
// -----------------------------------------------------------------------------

import { T } from "../i18n/translations";
import { getColors } from "../styles/theme";
import { Ic, ICONS } from "./Icons";

export default function ProductFormModal({
  lang,
  dark,
  accent,
  isStaff,
  form,
  setForm,
  editItem,
  onSave,
  onClose,
}) {
  const t = T[lang];
  const { textPrimary, textSecondary, borderColor } = getColors(dark);

  return (
    <div
      className="modal-bg"
      onClick={(e) => e.target === e.currentTarget && onClose()}
    >
      <div style={{ background:dark?"#0f0f1a":"#fff", border:`1px solid ${borderColor}`, borderRadius:18, padding:"22px", width:"100%", maxWidth:460, maxHeight:"90vh", overflowY:"auto" }}>
        <div style={{ display:"flex", justifyContent:"space-between", alignItems:"center", marginBottom:18 }}>
          <h2 style={{ fontSize:17, fontWeight:800, color:textPrimary }}>{editItem ? "Modifier" : "Ajouter un produit"}</h2>
          <button onClick={onClose} style={{ color:textSecondary, background:"none", border:"none", cursor:"pointer" }}>
            <Ic d={ICONS.close} size={18} />
          </button>
        </div>
        <div style={{ display:"grid", gridTemplateColumns:"1fr 1fr", gap:11 }}>
          <div style={{ gridColumn:"1/-1" }}>
            <label style={{ display:"block", fontSize:10, color:textSecondary, marginBottom:5, textTransform:"uppercase", letterSpacing:"1px" }}>{t.name} *</label>
            <input className="fi" value={form.name} onChange={(e)=>setForm({...form,name:e.target.value})} placeholder="ex: Pain Burger" />
          </div>
          <div>
            <label style={{ display:"block", fontSize:10, color:textSecondary, marginBottom:5, textTransform:"uppercase", letterSpacing:"1px" }}>{t.category}</label>
            <select className="fi" value={form.cat} onChange={(e)=>setForm({...form,cat:e.target.value})}>
              {T.fr.cats.map(c => <option key={c}>{c}</option>)}
            </select>
          </div>
          <div>
            <label style={{ display:"block", fontSize:10, color:textSecondary, marginBottom:5, textTransform:"uppercase", letterSpacing:"1px" }}>{t.unit}</label>
            <select className="fi" value={form.unit} onChange={(e)=>setForm({...form,unit:e.target.value})}>
              {T.fr.units.map(u => <option key={u}>{u}</option>)}
            </select>
          </div>
          <div>
            <label style={{ display:"block", fontSize:10, color:textSecondary, marginBottom:5, textTransform:"uppercase", letterSpacing:"1px" }}>{t.quantity} *</label>
            <input className="fi" type="number" min="0" value={form.qty} onChange={(e)=>setForm({...form,qty:e.target.value})} />
          </div>
          <div>
            <label style={{ display:"block", fontSize:10, color:textSecondary, marginBottom:5, textTransform:"uppercase", letterSpacing:"1px" }}>{t.alertAt}</label>
            <input className="fi" type="number" min="0" value={form.alert} onChange={(e)=>setForm({...form,alert:e.target.value})} />
          </div>
          <div>
            <label style={{ display:"block", fontSize:10, color:textSecondary, marginBottom:5, textTransform:"uppercase", letterSpacing:"1px" }}>{t.price}</label>
            <input className="fi" type="number" step="0.01" value={form.price} onChange={(e)=>setForm({...form,price:e.target.value})} placeholder="0.00" />
          </div>
          {!isStaff && (
            <div>
              <label style={{ display:"block", fontSize:10, color:textSecondary, marginBottom:5, textTransform:"uppercase", letterSpacing:"1px" }}>{t.sellPrice}</label>
              <input className="fi" type="number" step="0.01" value={form.sellPrice} onChange={(e)=>setForm({...form,sellPrice:e.target.value})} placeholder="0.00" />
            </div>
          )}
          <div>
            <label style={{ display:"block", fontSize:10, color:textSecondary, marginBottom:5, textTransform:"uppercase", letterSpacing:"1px" }}>{t.zone}</label>
            <select className="fi" value={form.zone} onChange={(e)=>setForm({...form,zone:e.target.value})}>
              {Object.keys(t.zones).map(z => <option key={z} value={z}>{t.zones[z]}</option>)}
            </select>
          </div>
          <div>
            <label style={{ display:"block", fontSize:10, color:textSecondary, marginBottom:5, textTransform:"uppercase", letterSpacing:"1px" }}>{t.dlc}</label>
            <input className="fi" type="date" value={form.dlc} onChange={(e)=>setForm({...form,dlc:e.target.value})} />
          </div>
        </div>
        <div style={{ display:"flex", gap:9, marginTop:18 }}>
          <button onClick={onClose} style={{ flex:1, padding:"11px", background:dark?"rgba(255,255,255,.06)":"rgba(0,0,0,.06)", borderRadius:9, color:textSecondary, fontWeight:600, border:"none", cursor:"pointer" }}>
            {t.cancel}
          </button>
          <button className="glow-btn" onClick={onSave} style={{ flex:1, padding:"11px", background:`linear-gradient(135deg,${accent},#f7931e)`, borderRadius:9, color:"#fff", fontWeight:700, border:"none", cursor:"pointer" }}>
            {t.save}
          </button>
        </div>
      </div>
    </div>
  );
}
